












import { HlAppModeMixin } from '@spa/mixins/hl-app-mode'
import { Component, Mixins } from 'vue-property-decorator'

@Component({})
export default class BackToMyPageTopButton extends Mixins<HlAppModeMixin>(HlAppModeMixin) {
  get label(): string {
    return this.hlAppMode.isPageForHlApp
      ? 'マイページに戻る'
      : 'アカウントサービスTOPへ'
  }

  onClick() {
    if (this.hlAppMode.isPageForHlApp) {
      this.closeWebView()
    } else {
      this.$router.push('/mypage')
    }
  }
}
